export default __webpack_public_path__ + "static/BATPEPE-7f845882edd4a595c1ec8fcfd0401cd4.jpg";